// declare necessary libraries
import { fetch as fetchPolyfill } from "whatwg-fetch";

import store from "../store";
import moment from "moment";
import ErrorService from "./ErrorService";
import Utils from "../helpers/utils";

require("moment-timezone/builds/moment-timezone-with-data-2012-2022.min.js");
import jstz from "jstimezonedetect";

export default class OOHService {
  constructor() {
    this.readConfig();
  }
  // read schedule configuration from external source in JSON format.
  readConfig() {
    this.config = store.state.jsonOOH;
  }

  // check whether current date is an holiday
  isOnHoliday(currDate) {
    if (this.config.holidays == null) {
      return null;
    }
    for (var i = 0; i < this.config.holidays.length; i++) {
      if (this.config.holidays[i].date == currDate.format("YYYY-MM-DD")) {
        Utils.log.debug("Holiday found", this.config.holidays[i]);
        return this.config.holidays[i];
      }
    }
    Utils.log.debug("No Holiday found");
    return null;
  }

  // get current datetime
  getCurrentTime() {
    var currentDateInServerTimeZone = moment();
    return currentDateInServerTimeZone;
  }

  // check whether current date is a special day
  isOnSpecialDay(currDate) {
    if (this.config.specialDays == null) {
      Utils.log.debug("No Special day found");
      return null;
    }

    for (var i = 0; i < this.config.specialDays.length; i++) {
      if (this.config.specialDays[i].date == currDate.format("YYYY-MM-DD")) {
        Utils.log.debug("Special day found", this.config.specialDays[i]);
        return this.config.specialDays[i];
      }
    }
    Utils.log.debug("No Special day found");
    return null;
  }

  // check whether current time is in operating hours.
  isInWorkingHour(workObj, current, message, messageInHours) {
    let workTime = workObj.workTime;
    let currFormat = current.format("HH:mm");
    let tempDate = "01/01/2011 ";
    let isOpen =
      Date.parse(tempDate + workTime.startTime) <=
        Date.parse(tempDate + currFormat) &&
      Date.parse(tempDate + workTime.endTime) >=
        Date.parse(tempDate + currFormat);
    Utils.log.debug("Is Open=" + isOpen);
    return {
      is_open: isOpen,
      message: isOpen ? messageInHours : message,
    };
  }

  getPostObj(body) {
    return {
      method: "POST",
      body: body.join("&"),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };
  }

  async performRequest(url, body) {
    try {
      const response = await fetchPolyfill(url, body);
      const text = await response.text();
      let xml2js = require('xml2js');

      // Without parser
      try{
         let parseResult =  xml2js.parseStringPromise(text /*, options */)
         return parseResult
      }
      catch(e){
         throw e;
      }
    } catch (e) {
      ErrorService.displayAlert(e.message);
      Utils.log.error(e);
      throw new Error(e);
    }
  }

  async getDataFromPRP(){
    let sendObj = {};
    let formBody = [];
    sendObj.AppId = store.state.appData.WidgetData.config.oohAppId;
    sendObj.WHName = store.state.appData.WidgetData.config.oohWhName;
    sendObj.datetime = new Date().toISOString();

    for (var property in sendObj) {
      let encodedKey = encodeURIComponent(property);
      let encodedValue = encodeURIComponent(sendObj[property]);
      formBody.push(encodedKey + "=" + encodedValue);
    }

    try {
      let ans = await this.performRequest(store.state.appData.WidgetData.config.oohPrpUrl, this.getPostObj(formBody));
      Utils.log.debug(`PrP OOH data for ${JSON.stringify(sendObj)} = ${JSON.stringify(ans)}`);
      return ans
    } catch (e) {
      throw new Error(e);
    }
  }


  // determine whether current datetime is in operating hour.
  //return obj with data and message
  async getOperatingStatus() {
    if(store.state.appData.WidgetData.config.oohIsUsePRP){
      try{
         let ans = await this.getDataFromPRP();
         if (ans && ans.WHSC &&  ans.WHSC.Error[0] === "false" ){
            let is_open = ans.WHSC.IsOpen[0] == 'true' ? true : false;
            Utils.log.debug('PrP Operating status:' + JSON.stringify({ is_open, message: ans.WHSC.ChatMessage[0] }))
            return { is_open, message: ans.WHSC.ChatMessage[0] };
         }
         else if (ans && ans.WHSC && ans.WHSC.Error[0] === "true" ){
            throw ans.WHSC.ErrorMessage[0];
         }
      }
      catch(e){
        Utils.log.error(e);
      }
    }
    var operatingHourObj = { is_open: false, message: "" };
    var current = this.getCurrentTime();
    var holiday = this.isOnHoliday(current);
    var specialDate = this.isOnSpecialDay(current);

    if (holiday) {      
      return { is_open: false, message: holiday.message };
    }

    if (specialDate) {
      return this.isInWorkingHour(
        specialDate,
        current,
        specialDate.message,
        specialDate.messageInHours
      );
    }

    if (this.config.routineDays) {
      // if days exist but empty so always working
      if (this.config.routineDays.days.length == 0) {
        return {
          is_open: true,
          message: this.config.routineDays.messageInHours
            ? this.config.routineDays.messageInHours
            : "",
        };
      }
      for (var i = 0; i < this.config.routineDays.days.length; i++) {
        if (this.config.routineDays.days[i].dow == current.day()) {
          return this.isInWorkingHour(
            this.config.routineDays.days[i],
            current,
            this.config.routineDays.message,
            this.config.routineDays.messageInHours
          );
        }
      }
    }
    Utils.log.debug('Operating status:' + JSON.stringify(operatingHourObj))
    return operatingHourObj;
  }
}
